// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-tarjeta.row.fadeOut {
  animation: fadeOut 1s;
}

.pagos-info-tarjeta {
  align-items: center;
  display: flex;
  margin-bottom: 2em;
}

.pagos-default {
  width: 17%;
}

.pagos-datos {
  border: 2px solid #2b363b;
  border-radius: 16px;
  padding: 0.9em 1.3em;
  width: 66%;
}

.pagos-remove {
  text-align: right;
  width: 17%;
}

.pagos-remove-icon {
  width: 24px;
  height: 24px;
}

.pagos-datos span {
  display: block;
}

.pagos-caducidad {
  font-size: 0.9em;
  color: #555;
}

.pagos-datos span:first-child {
  font-size: 1.1em;
  font-weight: 700;
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pagos-datos span:last-child {
  text-transform: uppercase;
}

.pagos-default .input-group-text {
  border: none;
}

.pagos-remove button:focus,
.pagos-remove button:active:focus {
  box-shadow: none;
}

.pagos-default input[type="radio"]:checked:after {
  content: "\\2714" !important;
  font-size: 1em;
  line-height: 1.3em;
}

.pagos-btn {
  background-color: #fff;
  bottom: 0;
  padding: 2% 0 4% 0;
  position: sticky;
  width: 94vw;
}

.pagos-btn-nueva {
  width: 100%;
}

.pagos-estado-img {
  margin: 0 auto;
  width: 18vw;
}

.pagos-estado-text,
.pagos-estado-info,
.pagos-estado-info-adicional {
  text-align: center;
}
.pagos-estado-text {
  font-size: 4.8vw;
  font-weight: 700;
}

.pagos-estado-info {
  font-size: 0.9em;
  font-weight: 800;
}

.pagos-estado-info-adicional {
  font-size: 0.8em;
  font-weight: 400;
}

.pagos-remove > button.user-config > img:hover {
  filter: invert(8%) sepia(13%) saturate(7%) hue-rotate(295deg) brightness(95%)
    contrast(320%);
}

table.historial-pagos span.input-group-text {
  border: none;
}

table.historial-pagos > :not(:first-child) {
  border-top: none;
}

table.historial-pagos tr {
  border-bottom: 1px solid rgba(230, 233, 241, 0.8);
}

table.historial-pagos td {
  padding-bottom: 1.7em;
  padding-top: 1.7em;
  vertical-align: middle;
}

table.historial-pagos th,
table.historial-pagos td {
  padding-right: 11vw;
  white-space: nowrap;
}

table.historial-pagos td.historial-nombre,
table.historial-pagos td.historial-tarjeta,
table.historial-pagos td.historial-marca {
  text-transform: uppercase;
}

.historial-fecha {
  color: #3d3d3d;
  font-weight: 600 !important;
}

span.historial-fecha-hora {
  display: block;
  font-weight: 400;
  font-size: 0.9em;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .pagos-default {
    width: 15%;
  }

  .pagos-default input[type="radio"]:checked:after {
    line-height: 1.2em;
  }

  .pagos-btn-nueva {
    font-size: 1em;
    width: -moz-fit-content;
    width: fit-content;
  }

  .pagos-estado-img {
    margin: 0 auto;
    max-width: 100px;
  }

  .pagos-estado-text,
  .pagos-estado-info,
  .pagos-estado-info-adicional {
    max-width: 50%;
    margin: 0 auto;
    display: block;
  }

  .pagos-estado-text {
    font-size: 1.7em;
  }

  .pagos-estado-info {
    font-size: 0.9em;
    font-weight: 800;
  }

  .pagos-estado-info-adicional {
    font-size: 0.8em;
    font-weight: 400;
  }

  table.historial-pagos th,
  table.historial-pagos td {
    padding-right: 1.5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/flotas/pago/metodospago.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;IACd,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;EACtB;AACF","sourcesContent":[".row-tarjeta.row.fadeOut {\n  animation: fadeOut 1s;\n}\n\n.pagos-info-tarjeta {\n  align-items: center;\n  display: flex;\n  margin-bottom: 2em;\n}\n\n.pagos-default {\n  width: 17%;\n}\n\n.pagos-datos {\n  border: 2px solid #2b363b;\n  border-radius: 16px;\n  padding: 0.9em 1.3em;\n  width: 66%;\n}\n\n.pagos-remove {\n  text-align: right;\n  width: 17%;\n}\n\n.pagos-remove-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.pagos-datos span {\n  display: block;\n}\n\n.pagos-caducidad {\n  font-size: 0.9em;\n  color: #555;\n}\n\n.pagos-datos span:first-child {\n  font-size: 1.1em;\n  font-weight: 700;\n  margin-bottom: 0.2em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pagos-datos span:last-child {\n  text-transform: uppercase;\n}\n\n.pagos-default .input-group-text {\n  border: none;\n}\n\n.pagos-remove button:focus,\n.pagos-remove button:active:focus {\n  box-shadow: none;\n}\n\n.pagos-default input[type=\"radio\"]:checked:after {\n  content: \"\\2714\" !important;\n  font-size: 1em;\n  line-height: 1.3em;\n}\n\n.pagos-btn {\n  background-color: #fff;\n  bottom: 0;\n  padding: 2% 0 4% 0;\n  position: sticky;\n  width: 94vw;\n}\n\n.pagos-btn-nueva {\n  width: 100%;\n}\n\n.pagos-estado-img {\n  margin: 0 auto;\n  width: 18vw;\n}\n\n.pagos-estado-text,\n.pagos-estado-info,\n.pagos-estado-info-adicional {\n  text-align: center;\n}\n.pagos-estado-text {\n  font-size: 4.8vw;\n  font-weight: 700;\n}\n\n.pagos-estado-info {\n  font-size: 0.9em;\n  font-weight: 800;\n}\n\n.pagos-estado-info-adicional {\n  font-size: 0.8em;\n  font-weight: 400;\n}\n\n.pagos-remove > button.user-config > img:hover {\n  filter: invert(8%) sepia(13%) saturate(7%) hue-rotate(295deg) brightness(95%)\n    contrast(320%);\n}\n\ntable.historial-pagos span.input-group-text {\n  border: none;\n}\n\ntable.historial-pagos > :not(:first-child) {\n  border-top: none;\n}\n\ntable.historial-pagos tr {\n  border-bottom: 1px solid rgba(230, 233, 241, 0.8);\n}\n\ntable.historial-pagos td {\n  padding-bottom: 1.7em;\n  padding-top: 1.7em;\n  vertical-align: middle;\n}\n\ntable.historial-pagos th,\ntable.historial-pagos td {\n  padding-right: 11vw;\n  white-space: nowrap;\n}\n\ntable.historial-pagos td.historial-nombre,\ntable.historial-pagos td.historial-tarjeta,\ntable.historial-pagos td.historial-marca {\n  text-transform: uppercase;\n}\n\n.historial-fecha {\n  color: #3d3d3d;\n  font-weight: 600 !important;\n}\n\nspan.historial-fecha-hora {\n  display: block;\n  font-weight: 400;\n  font-size: 0.9em;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .pagos-default {\n    width: 15%;\n  }\n\n  .pagos-default input[type=\"radio\"]:checked:after {\n    line-height: 1.2em;\n  }\n\n  .pagos-btn-nueva {\n    font-size: 1em;\n    width: fit-content;\n  }\n\n  .pagos-estado-img {\n    margin: 0 auto;\n    max-width: 100px;\n  }\n\n  .pagos-estado-text,\n  .pagos-estado-info,\n  .pagos-estado-info-adicional {\n    max-width: 50%;\n    margin: 0 auto;\n    display: block;\n  }\n\n  .pagos-estado-text {\n    font-size: 1.7em;\n  }\n\n  .pagos-estado-info {\n    font-size: 0.9em;\n    font-weight: 800;\n  }\n\n  .pagos-estado-info-adicional {\n    font-size: 0.8em;\n    font-weight: 400;\n  }\n\n  table.historial-pagos th,\n  table.historial-pagos td {\n    padding-right: 1.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
